// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCI5Y2gw9BkFscTAyeSMHyT3slH5vOjdcA",
  authDomain: "oing-portfolio.firebaseapp.com",
  projectId: "oing-portfolio",
  storageBucket: "oing-portfolio.firebasestorage.app",
  messagingSenderId: "248619525854",
  appId: "1:248619525854:web:12e6dafdd2bb3efb3e844f",
  measurementId: "G-VWMBD89NG7",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
